// extracted by mini-css-extract-plugin
export default {"pagination":"IXl3_Btka_VcI00Y2qjU","paginationMobile":"M01ELiHiIl7TTEVudZDP","paginationLabel":"pbpj8Ry6x2mODTlIoMhU","outOfTotal":"Ss40aL6YPYN15mj3fD1n"};